import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    counterContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        paddingTop: theme.spacing(4),
    },
    counterTitleTypography: {
        textAlign: "left",
    },
    counterTitle: {
        color: theme.palette.primary.dark,
        margin: 0,
        textAlign: "left",
    },
    counterClock: {
        color: theme.palette.text.primary,
        textAlign: "left",
    },
}));
